import { useEffect, useState } from "react";
import getSpinnerVerb from "utils/getSpinnerVerb";

const VERB_ROTATION_MS = 2500;

export default function useRotatingSpinnerVerb(active: boolean) {
  const [verb, setVerb] = useState(getSpinnerVerb);

  useEffect(() => {
    if (!active) return;

    setVerb(getSpinnerVerb());
    const intervalId = setInterval(
      () => setVerb(getSpinnerVerb()),
      VERB_ROTATION_MS,
    );

    return () => clearInterval(intervalId);
  }, [active]);

  return verb;
}
